import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './style.scss';
import Input from 'common/components/elements/inputs/inputs';
import cx from 'classnames';

const InputRange = ({
   onChange,
   value,
   disabled,
   className,
   name,
   minValue,
   maxValue,
   step,
   label,
   withTyping,
   inputClassName,
   inputLabel,
   inputWrapperClassName = '',
   updateStateOnValueChange = false,
   showValueWithPercent,
   valueWithPercentClassName = '',
   labelClassName = 'uppercase text-sm text-secondary dark:text-secondary-dark mb-4',
}) => {
   const [percent, setPercent] = useState(0)
   const [inputValue, setInputValue] = useState(value)

   useEffect(() => {
      const percent = ((value - minValue) / (maxValue - minValue)) * 100
      setPercent(percent)
      setInputValue(value)
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [value])

   useEffect(() => {
      if(!updateStateOnValueChange) return;


      const percent = ((value - minValue) / (maxValue - minValue)) * 100;
      setPercent(percent)
      setInputValue(value)

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [value])

   function onInputChange(e) {
      const { name, value, min, max } = e.target;
      if(Number(value) < minValue || Number(value) > maxValue) {
         return
      }
      const percent = ((value - min) / (max - min)) * 100;
      setPercent(percent)
      setInputValue(value)
      onChange(name, value)
   }

   function onKeyUp(e) {
      if((8 === e.keyCode || 46 === e.keyCode) && !e.target.value) {
         setInputValue(minValue + step)
      }
   }

   return (
      <div className={ cx({
         'w-full flex flex-col items-center base-input-range': true,
         [className]: className,
      }) }>
         <div className='flex justify-between items-center w-full gap-3'>
            {
               label && (
                  <span className={ cx({
                     [labelClassName]: labelClassName,
                     '!text-disabled cursor-default': disabled,
                  }) }>{label} </span>
               )
            }
            {
               showValueWithPercent && (
                  <span className={ cx({
                     [valueWithPercentClassName]: valueWithPercentClassName,
                     '!text-disabled cursor-default': disabled,
                  }) }>{inputValue}% </span>
               )
            }
         </div>
         {
            withTyping && (
               <div className={ `mb-4 ${ inputWrapperClassName }` }>
                  <Input
                     type='number'
                     value={ inputValue }
                     onInput={ onInputChange }
                     onChange={ (name, value) => {
                        if(Number(value) < minValue || Number(value) > maxValue) {
                           return
                        }
                        onChange(name, value)
                     } }
                     min={ minValue }
                     max={ maxValue }
                     step={ step }
                     name={ name }
                     pattern={ `[${ minValue }-${ maxValue }]*` }
                     onKeyUp={ onKeyUp }
                     className={ inputClassName }
                     height='10'
                     label={ inputLabel }
                  />
               </div>
            )
         }
         <div className='w-full'>
            <input
               type='range'
               name={ name }
               min={ minValue }
               max={ maxValue }
               step={ step }
               value={ inputValue }
               className={ cx({
                  'w-full': true,
                  'cursor-pointer': !disabled,
               }) }
               onChange={ (e) => {
                  const { name, value } = e.target;
                  if(Number(value) < minValue || Number(value) > maxValue) {
                     return
                  }
                  onChange(name, value)
               } }
               onInput={ onInputChange }
               disabled={ disabled }
               style={ {
                  backgroundImage: `linear-gradient(to right, ${ disabled ? '#D0D5DD' : '#231FFF' } 0%, ${ disabled ? '#D0D5DD' : '#231FFF' } ${ percent }%, #F2F4F7 ${ percent }%, #F2F4F7  100%)`,
               } }
            />
         </div>
      </div>
   );
};

InputRange.defaultProps = {
   onChange: () => {},
   minValue: 0,
   maxValue: 100,
   step: 1,
   value: 4,
   name: 'range',
   disabled: false,
   withTyping: true,
   className: '',
   inputClassName: '',
};

InputRange.propTypes = {
   onChange: PropTypes.func,
   minValue: PropTypes.number,
   maxValue: PropTypes.number,
   name: PropTypes.string,
   label: PropTypes.string,
   inputLabel: PropTypes.string,
   step: PropTypes.number,
   value: PropTypes.any,
   disabled: PropTypes.bool,
   withTyping: PropTypes.bool,
   className: PropTypes.string,
   inputClassName: PropTypes.string,
   inputWrapperClassName: PropTypes.string,
   updateStateOnValueChange: PropTypes.bool,
   showValueWithPercent: PropTypes.bool,
   valueWithPercentClassName: PropTypes.string,
   labelClassName: PropTypes.string,
};

export default InputRange;
